<template>
  <div id="Gamemaster" :class="mainCSS">
    <div id="messages" v-if="msg">
      {{ msg }}
    </div>
    <div id="outerPopUp" v-if="showPopUp">
      <div id="PopUp">
        <div>{{ popUpText }}</div>
        <div>Are you sure?</div>
        <div class="yes_no_holder">
          <button class="yes" @click="popUp('yes')">YES</button>
          <button class="no" @click="popUp('no')">NO</button>
        </div>
      </div>
    </div>

    <div id="name_count_score">
      <div v-for="(p, index) in participants" :key="p" class="userHolder">
        <div class="userName">
          {{ index }}
        </div>
        <div class="userNameAlt">
          {{ p.nameAlt }}
        </div>
        <div class="answers_given">
          {{ answers_given(p, index) }}
        </div>
        <div class="score">
          {{ score(p) }}
        </div>
      </div>
    </div>

    <div id="score_statistics">
      <div><strong>Hi</strong> {{ highScore() }}</div>
      <div><strong>Av</strong> {{ averageScore() }}</div>
      <div><strong>Med</strong> {{ medianScore() }}</div>
    </div>

    <div id="all_feedback">
      <div v-for="p in orderedParticipantsArray" :key="p" class="feedback">
        <div class="text">
          {{ p[0] }}
        </div>
        <div class="delete_button" @click="delete_feedback(p[4], p[2], p[3])">
          delete
        </div>
      </div>
    </div>

    <div class="announceWinners" @click="announceWinners">Announce Winners</div>

    <div id="delete_all" @click="delete_all">delete all scores</div>
    <div id="removeInfo">Click below to remove players. CAUTION!</div>

    <div id="removePlayerHolder">
      <div
        v-for="(p, index) in participants"
        :key="p"
        class="userHolder removeHolder"
        @click="removePlayer(index)"
      >
        <div class="userName">
          {{ index }}
        </div>
        <div class="userNameAlt">
          {{ p.nameAlt }}
        </div>
        <div class="userNameAlt">REMOVE</div>
      </div>
    </div>

    <div id="RoomInfo">{{ roomInfo.roomCode }} - {{ roomInfo.created }}</div>
    <div id="version">v0.6</div>
  </div>
</template>

<script>
import DeviceDetector from "device-detector-js";

export default {
  name: "GameMaster",
  components: {},
  data() {
    return {
      deviceDetector: {},
      token: this.$route.query.token,
      roomInfo: {},
      msg: "",
      msgTimer: null,
      participants: {},
      orderedParticipantsArray: [],
      currentEntry: -1,
      showPopUp: false,
      popUpFunction: function () {},
      mainCSS: "",
      device: {},
    };
  },
  watch: {
    participants: function (newV) {
      this.orderParticipants(newV);
    },
  },

  methods: {
    removePlayer(index) {
      if (!this.participants[index]) return false;
      this.generatePopUp("Remove player " + index);
      this.popUpFunction = function () {
        this.$http
          .post("/removePlayer", {
            token: this.token,
            playerToRemove: index, //damit wissen wir schon die credentials und den richtigen Raum
          })
          .then((res) => {
            // console.log(res);
            if (res.status === 200 && res.data.type == "success") {
              this.setMessage(res.data.msg);
              return true;
            }
            this.setMessage(res.data.msg);
            return false;
          });
      };
    },
    generatePopUp(text) {
      this.showPopUp = true;
      this.popUpText = text;
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.mainCSS = "disableScrolling";
    },
    announceWinners() {
      //CAUTION POPUP NEEDED
      this.generatePopUp("Announcing winner");
      this.popUpFunction = function () {
        this.$http
          .post("/winner", {
            token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          })
          .then((res) => {
            // console.log(res);
            if (res.status === 200 && res.data.type == "success") {
              this.setMessage(res.data.msg);
              return true;
            }
            this.setMessage(res.data.msg);
            return false;
          });
      };
    },
    popUp(answer) {
      if (answer == "yes") {
        //confirm action, use function
        this.popUpFunction();
        this.popUpFunction = function () {};
        this.popUpText = "";
      }
      //everything else does not matter, close popUp
      this.showPopUp = false;
      this.mainCSS = "";
    },
    orderParticipants(participants) {
      this.orderedParticipantsArray = [];
      for (const p in participants) {
        for (const u in participants[p]) {
          if (u == "score" || u == "winner" || u == "nameAlt") continue;
          for (const answer in participants[p][u]) {
            this.orderedParticipantsArray.push([
              "Feedback von " +
                answer +
                " an " +
                p +
                " zu " +
                u +
                ": " +
                this.calc_score(participants[p][u][answer]),
              participants[p][u][answer].time,
              p, //2
              u, //3
              answer, //4
            ]);
          }
        }
      }
      this.orderedParticipantsArray.sort(function compareFn(a, b) {
        return b[1] - a[1];
        //>0 sort a after b
      });
    },
    delete_feedback(from, to, question) {
      this.$http
        .post("/deleteFeedback", {
          token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          from: from,
          to: to,
          question: question,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.type == "success") {
            this.setMessage(res.data.msg);
            return true;
          }
          this.setMessage(res.data.msg);
          return false;
        });
    },
    delete_all() {
      //CAUTION POPUP NEEDED
      this.generatePopUp("Deleting all scores!");
      this.popUpFunction = function () {
        // console.log("yes");
        this.$http
          .post("/deleteAll", {
            token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          })
          .then((res) => {
            // console.log(res);
            if (res.status === 200 && res.data.type == "success") {
              this.setMessage(res.data.msg);
              return true;
            }
            this.setMessage(res.data.msg);
            return false;
          });
      };
    },
    calc_score(answer) {
      // console.log(answer);
      let s = 0;
      for (const a of answer.data) {
        s += a;
      }
      return this.scoreFilter((s / 30) * 100);
    },
    coolDown() {
      if (this.coolDownTimer) {
        this.setMessage("please wait at least 3 seconds for your next request");
        return true;
      }
      this.coolDownTimer = setTimeout(() => {
        this.coolDownTimer = null;
      }, 3000);
      return false;
    },
    setMessage(msg) {
      this.msg = msg;
      if (this.msgTimer) {
        clearTimeout(this.msgTimer);
      }
      this.msgTimer = setTimeout(() => {
        this.msg = "";
      }, 3000);
    },
    answers_given(p) {
      let count = "";
      for (const question in p) {
        if (
          question == "score" ||
          question == "winner" ||
          question == "nameAlt"
        )
          continue;
        // console.log(
        //   index + "@" + question + ": " + Object.keys(p[question]).length
        // );
        if (Object.keys(p[question]).length >= 1) count += question;
      }
      if (!count) return "-";
      return count;
    },
    total_answers_received(p) {
      let count = 0;
      for (const question in p) {
        if (
          question == "score" ||
          question == "winner" ||
          question == "nameAlt"
        )
          continue;
        count += Object.keys(p[question]).length;
      }
      return count;
    },
    score(p) {
      if (p.score <= 0) return this.scoreFilter(0);
      let count = 0;
      for (const u in p) {
        if (u == "score" || u == "winner" || u == "nameAlt") continue;
        count += Object.keys(p[u]).length;
      }
      return this.scoreFilter(p.score / count);
    },
    highScore() {
      let winnerScore = 0;
      let newScore = 0;
      var winnerObj = {};
      for (const p in this.participants) {
        let score = this.participants[p].score;
        if (score <= 0) continue;
        newScore = score / this.total_answers_received(this.participants[p]);
        if (newScore > winnerScore) {
          winnerObj = {};
          winnerScore = newScore;
          winnerObj[p] = newScore;
        } else if (newScore == winnerScore) {
          winnerObj[p] = newScore;
        }
      }
      if (winnerScore == 0) return "--";

      // console.log(winnerObj);

      let s = "";
      var first = true;

      for (const p in winnerObj) {
        if (first) {
          s += p;
          first = false;
        } else s += "," + p;
      }
      return s + " " + this.scoreFilter(winnerScore);
    },
    averageScore() {
      let sumScore = 0;
      let newScore = 0;
      let anzahl = 0;

      if (!this.participants) return 0;

      for (const p in this.participants) {
        let answers = this.total_answers_received(this.participants[p]);
        if (answers <= 0) continue;
        newScore = this.participants[p].score / answers;
        if (!newScore) newScore = 0;
        sumScore += newScore;
        anzahl++;
      }
      if (anzahl == 0) return this.scoreFilter(0);
      sumScore /= anzahl;
      sumScore = this.scoreFilter(sumScore);

      return sumScore;
    },
    medianScore() {
      const defaultReturn = "--";
      if (!this.participants) return defaultReturn;
      let players = [];
      let s = 0;
      for (const p in this.participants) {
        let answers = this.total_answers_received(this.participants[p]);
        if (answers <= 0) continue;
        s = this.participants[p].score / answers;
        if (!s) s = 0;
        players.push([p, s]);
      }
      // console.log(players);
      if (players.length <= 0) return defaultReturn;

      players.sort(function (a, b) {
        return a[1] - b[1];
      });

      try {
        let medianPlayer = Math.round(players.length / 2) - 1;
        return (
          players[medianPlayer][0] +
          " " +
          this.scoreFilter(players[medianPlayer][1])
        );
      } catch (e) {
        console.log(e);
        return defaultReturn;
      }
    },
    checkToken() {
      this.$http
        .post("/checkToken", {
          token: this.token,
          device: this.device,
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.setMessage(res.data.msg);
            if (res.data.type == "success") {
              this.participants = res.data.room; //Grundstruktur

              if (res.data.userType != "GM") {
                this.setMessage("ERROR you are not Gamemaster");
                return false;
              }
              this.roomInfo = res.data.decoded;
              this.createInterval();
              console.log("token success");
              return true;
            }
          } else {
            this.setMessage(
              "cannot connect to server, please check your connection or reload the page"
            );
            // this.setMessage('error bei der Verbindung zum Server, versuchen sie es erneut, checken sie die Internetverbindung...')
            return false;
          }
        });
    },
    readRoom() {
      this.$http
        .post("/readRoom", {
          token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          currentEntry: this.currentEntry,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.type == "success") {
            // console.log("success, readRoom");
            if (res.data.emptyRoom) {
              // console.log("no new Data");
              return true;
            }

            console.log("READING ROOM GOT NEW DATA");
            console.log(res.data.room);
            this.participants = res.data.room;
            this.currentEntry = res.data.currentEntry;
            return true;
          }
          return false;
        });
    },
    createInterval() {
      setInterval(this.readRoom, 1000);
    },
    scoreFilter(score) {
      if (score == 0) return "--,-";
      let s = Math.round(score * 10) / 10;

      s = parseFloat(s).toLocaleString("de-DE");
      if (!String(s).includes(",")) {
        return s + ",0";
      }
      return s;
    },
    dateFilter(timestamp) {
      var d = new Date(timestamp);
      // dd/MM/yy - HH:MM
      console.log(d.getDay());
      return d.getDay() + "/" + d.getMonth();
    },
  },
  created() {
    let userAgent = window.navigator.userAgent;
    this.device = new DeviceDetector().parse(userAgent);

    this.checkToken();
  },
};
</script>

<style scoped>
.removeHolder:hover {
  background: red;
  color: white;
  cursor: pointer;
}

#removePlayerHolder {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.userNameAlt {
  font-size: 18px;
}

.disableScrolling {
  height: 100vh;
  overflow: hidden;
}

.announceWinners:active {
  background: #ff9000;
  color: black;
}

.announceWinners {
  background: white;
  color: #ff9000;
  border: 3px solid #ff9000;
  font-size: 1.8em;
  width: 50%;
  text-align: center;
  line-height: 1.7em;
  border-radius: 5px;
  margin: 20px auto;
}

#delete_all:active {
  background: red;
  color: white;
}

#delete_all:hover,
.announceWinners:hover {
  cursor: pointer;
}

#removeInfo {
  color: white;
  background: red;
  border: 3px solid black;
  font-size: 1.8em;
  width: 50%;
  text-align: center;
  line-height: 1.7em;
  border-radius: 5px;
  margin: 10px auto;
}

#delete_all {
  background: white;
  color: red;
  border: 3px solid red;
  font-size: 1.8em;
  width: 50%;
  text-align: center;
  line-height: 1.7em;
  border-radius: 5px;
  margin: 10px auto;
}

#PopUp {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 30%;
  height: 10%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  border: 2px solid;
  border-radius: 7px;
}

.yes,
.no {
  width: 70px;
  height: 30px;
  font-size: 1.2em;
}

.yes_no_holder {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

#outerPopUp {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background: #ac0a422e;
  backdrop-filter: blur(2px);
}

#score_statistics {
  display: flex;
  width: 100%;
  font-size: 1.75em;
  justify-content: space-evenly;
  margin: 30px 0px;
}

#all_feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feedback {
  display: flex;
  font-size: 1.5em;
  flex-direction: row;
  align-items: center;
  width: min(75%, 500px);
  margin: 10px 30px 10px 10px;
  background: #6495ed1c;
  justify-content: space-around;
  border-radius: 5px;
  padding: 5px;
}

.delete_button:active {
  background: red;
  color: white;
}

.delete_button {
  margin-left: 20px;
  border: 2px solid;
  padding: 2px;
  border-radius: 3px;
  font-size: 0.8em;
}

#name_count_score {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.userHolder {
  min-width: 50px;
  text-align: center;
  border: 1px solid black;
  margin: 5px;
  flex: 1 1 calc(11% - 10px);
  font-size: 1.5em;
}

#version {
  position: fixed;
  right: 0px;
  bottom: 0px;
}

#messages {
  font-size: min(8vw, 35px);
  position: absolute;
  z-index: 3;
  background: red;
  top: 0px;
  width: 100%;
  text-align: center;
  padding: 20px 0;
  left: 0px;
}

#Gamemaster {
  max-width: 650px;
  margin: 0 auto;
}
</style>
